import { useHistory } from "react-router-dom";
import clientAxios from "../config/axios";
import { types } from "../types";
import {
  errorAlert,
  removeSuccessAlertModal,
  setSuccessAlertModal,
} from "./alerts";
import { getCourses } from "./course";
import { getStudents } from "./student";
import { setLoading, removeLoading, closeModal, openModal } from "./ui";
import { getVisas } from "./visa";



//Proposal

export const getProposals = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get("/api/v1/proposals/all");
      dispatch({
        type: types.getProposal,
        payload: result.data.allproposals,
      });
      
    } catch (error) {
      console.log(error);
    }
    dispatch(removeLoading());
  };
};

export const createProposal = (proposal) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.post("/api/v1/proposals", proposal);

      dispatch({
        type: types.createProposal,
        payload: result.data,
      });

      dispatch({
        type: types.setProposalCreated,
        payload: result.data,
      });

      dispatch(openModal());

      dispatch(
        setSuccessAlertModal(
          `${result.statusText} Proposal Created`,
          result.status
        )
      );
    } catch (error) {
      // console.log(error.response);
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const deleteProposal = (proposalId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      await clientAxios.delete(`/api/v1/proposals/${proposalId}`);
      dispatch({
        type: types.deleteProposal,
        payload: proposalId,
      });
     
      dispatch(removeLoading());

      dispatch(closeModal()); //Mejorar mover
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const updateProposal = (proposal) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.put(
        `/api/v1/proposals/${proposal._id}`,
        proposal
      );

      dispatch({
        type: types.updateProposal,
        payload: result.data.proposal,
      });

      dispatch({
        type: types.setProposalUpdated,
        payload: result.data.proposal,
      });

      dispatch(openModal());
      dispatch(
        setSuccessAlertModal(
          `${result.statusText} Proposal Updated`,
          result.status
        )
      );
    } catch (error) {
      // console.log(error);

      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const clearProposal = () => {
  return (dispatch) => {
    dispatch(removeStudentFromProposal());
    dispatch(clearCoursesFromProposal());
    dispatch(clearVisasFromProposal());
    // dispatch(removeVisaFromProposal());
    // dispatch(removeInsuranceFromProposal());
    dispatch(clearInsuranceFromProposal());
    dispatch(removeNoteFromProposal());
    dispatch(removeCreatedProposal());
    dispatch(removeSuccessAlertModal());
    dispatch(removeProposalfromUpdating());
    dispatch(removeUpdateProposal());
  };
};

export const ContinueEditing = (id) => {
  const history = useHistory();
  return () => {
    history.push(`/creator/proposals/section-proposal/${id}`);
  };
};

export const removeCreatedProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeProposalCreated,
    });
  };
};
export const removeUpdateProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeProposalUpdated,
    });
  };
};

//Settings Proposal
export const setProposalToUpdating = (proposal) => {
  return (dispatch) => {
    dispatch({ type: types.setProposalToUpdate, payload: proposal });
  };
};

export const removeProposalfromUpdating = () => {
  return (dispatch) => {
    dispatch({ type: types.removeProposalfromUpdate });
  };
};

export const setProposalToDeleting = (proposalId) => {
  return (dispatch) => {
    dispatch({ type: types.setProposalToDelete, payload: proposalId });
  };
};
export const removeProposalFromDeleting = () => {
  return (dispatch) => {
    dispatch({ type: types.removeProposalfromDelete });
  };
};

//Student
export const chooseStudent = () => {
  // Abre modal y pide los studiantes
  return (dispatch) => {
    dispatch(openModal());
    dispatch(getStudents());
    dispatch(addingStudent());
  };
};

export const addStudentToProposal = (student) => {
  // anade estudiantes
  return (dispatch) => {
    dispatch({
      type: types.setSelectedStudent,
      payload: student,
    });
  };
};
export const removeStudentFromProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeSelectedStudent,
    });
  };
};

export const addingStudent = () => {
  // action ayuda a abrir el modal
  return (dispatch) => {
    dispatch({
      type: types.addingStudent,
    });
  };
};
export const removingStudent = () => {
  return (dispatch) => {
    dispatch({
      type: types.removingStudent,
    });
  };
};

//Course
export const chooseCourses = () => {
  return (dispatch) => {
    dispatch(openModal());
    dispatch(getCourses());
    dispatch(addingCourses());
  };
};

export const addCoursesToProposal = (course) => {
  return (dispatch) => {
    dispatch({
      type: types.setSelectedCourse,
      payload: course, ///
    });
  };
};
export const removeCoursesFromProposal = (courseId) => {
  return (dispatch) => {
    dispatch({
      type: types.removeSelectedCourse,
      payload: courseId,
    });
  };
};

// export const updateCourseInProposal = (course) => {
//   return (dispatch) => {
//     dispatch({
//       type: types.removeSelectedCourse,
//       payload: course,
//     });
//   };
// };

export const clearCoursesFromProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.clearSelectedCourses,
    });
  };
};

export const addingCourses = () => {
  return (dispatch) => {
    dispatch({
      type: types.addingCourses,
    });
  };
};
export const removingCourses = () => {
  return (dispatch) => {
    dispatch({
      type: types.removingCourses,
    });
  };
};

export const updatingCourseAdded = () => {
  //aca abro modal para editar
  return (dispatch) => {
    dispatch({
      type: types.updatingCourseInProposal,
    });
  };
};

export const removeUpdatingCourseAdded = () => {
  //aca cierro modal para editar
  return (dispatch) => {
    dispatch({
      type: types.removeUpdatingCourseInProposal,
    });
  };
};

export const setCourseUpdatingInProposal = (course) => {
  //alisto el objeto para editar
  return (dispatch) => {
    dispatch({
      type: types.setCourseToUpdateInProposal,
      payload: course,
    });
  };
};

export const updateCourseSelected = (course) => {
  // aca edita el objeto en propuesta osea el ya añadido
  return (dispatch) => {
    dispatch({
      type: types.updateCourseSelected,
      payload: course,
    });
  };
};

//Visa

export const chooseVisa = () => {
  return (dispatch) => {
    dispatch(openModal());
    dispatch(getVisas());
    dispatch(addingVisa());
  };
};

export const addVisaToProposal = (visa) => {
  return (dispatch) => {
    dispatch({
      type: types.setSelectedVisa,
      payload: visa,
    });
  };
};

export const removeVisaFromProposal = (visaId) => {
  return (dispatch) => {
    dispatch({
      type: types.removeSelectedVisa,
      payload: visaId,
    });
  };
};

export const clearVisasFromProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.clearSelectedVisas,
    });
  };
};

export const addingVisa = () => {
  return (dispatch) => {
    dispatch({
      type: types.addingVisa,
    });
  };
};

export const removingVisa = () => {
  return (dispatch) => {
    dispatch({
      type: types.removingVisa,
    });
  };
};

export const updatingVisaAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.updatingVisaInProposal,
    });
  };
};
export const removeUpdatingVisaAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeUpdatingVisaInProposal,
    });
  };
};

export const setVisaUpdatingInProposal = (visa) => {
  return (dispatch) => {
    dispatch({
      type: types.setVisaToUpdateInProposal,
      payload: visa,
    });
  };
};

export const updateVisaSelected = (visa) => {
  return (dispatch) => {
    dispatch({
      type: types.updateVisaSelected,
      payload: visa,
    });
  };
};

//Insurance
export const chooseInsurance = () => {
  return (dispatch) => {
    dispatch(openModal());
    dispatch(addingInsurance());
  };
};

export const addInsuranceToProposal = (insurance) => {
  return (dispatch) => {
    dispatch({
      type: types.setSelectedInsurance,
      payload: insurance,
    });
  };
};

export const removeInsuranceFromProposal = (insuranceId) => {
  return (dispatch) => {
    dispatch({
      type: types.removeSelectedInsurance,
      payload: insuranceId,
    });
  };
};

export const clearInsuranceFromProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.clearSelectedInsurance,
    });
  };
};

export const addingInsurance = () => {
  return (dispatch) => {
    dispatch({
      type: types.addingInsurance,
    });
  };
};
export const removingInsurance = () => {
  return (dispatch) => {
    dispatch({
      type: types.removingInsurance,
    });
  };
};

////////////////////////
export const updatingInsuranceAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.updatingInsuranceInProposal,
    });
  };
};
export const removeUpdatingInsuranceAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeupdatingInsuranceInProposal,
    });
  };
};
export const setInsuranceUpdatingInProposal = (insurance) => {
  return (dispatch) => {
    dispatch({
      type: types.setInsuranceToUpdateInProposal,
      payload: insurance,
    });
  };
};
export const updateInsuranceSelected = (insurance) => {
  return (dispatch) => {
    dispatch({
      type: types.updateInsuranceSelected,
      payload: insurance,
    });
  };
};
////////////////////////

//Note
export const chooseNote = () => {
  return (dispatch) => {
    dispatch(openModal());
    dispatch(addingNote());
  };
};

export const addNoteToProposal = (note) => {
  return (dispatch) => {
    dispatch({
      type: types.setSelectedNote,
      payload: note,
    });
  };
};

export const removeNoteFromProposal = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeSelectedNote,
    });
  };
};

export const addingNote = () => {
  return (dispatch) => {
    dispatch({
      type: types.addingNote,
    });
  };
};
export const removingNote = () => {
  return (dispatch) => {
    dispatch({
      type: types.removingNote,
    });
  };
};

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
export const updatingNoteAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.updatingNoteInProposal,
    });
  };
};
export const removeUpdatingNoteAdded = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeUpdatingNoteInProposal,
    });
  };
};
export const setNoteUpdatingInProposal = (note) => {
  return (dispatch) => {
    dispatch({
      type: types.setNoteToUpdateInProposal,
      payload: note,
    });
  };
};
export const updateNoteSelected = (note) => {
  return (dispatch) => {
    dispatch({
      type: types.updateNoteSelected,
      payload: note,
    });
  };
};
